module.exports = __webpack_public_path__ + "img/Listening_to_user_input.f9fed663.gif";